import { BlocksIconAddCircle } from 'blocks-nextjs/blocks-web-components/components/icon/icons/add-circle';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconAddCircle = createComponent({ react: React, tagName: 'cat-icon-add-circle', elementClass: BlocksIconAddCircle });
